import { apiProxyRequest } from "Api/apiProxyRequest";

import type {
  AddPaymentSourcePayload,
  AddPaymentSourceResponse
} from "../types";

export const addProfilePaymentSourceRequest = (
  billingProfileId: string,
  payload: AddPaymentSourcePayload
) => {
  return apiProxyRequest<AddPaymentSourceResponse>(
    `/billing/profiles/${billingProfileId}/payment-source`,
    "POST",
    payload
  );
};
